import React, { useState, useEffect, useRef } from 'react'
import styles from './homePage.scss'
import { doPrePhone } from '@/events'
import { useNavigate, Link } from 'react-router-dom'
import User from '@/modules/user'
import ball from '@/common/images/pageHome/h-1.png'
import yds_1 from '@/common/images/pageHome/yd-s1.png'
import yds_2 from '@/common/images/pageHome/yd-s2.png'
import yds_3 from '@/common/images/pageHome/yd-s3.png'
import yds_4 from '@/common/images/pageHome/yd-s4.png'
import yd_head from '@/common/images/pageHome/yd-head.png'
import yd_product from '@/common/images/pageHome/yd-product.png'
import product_bg from '@/common/images/pageHome/product-bg.jpg'
import s_1 from '@/common/images/pageHome/s-1.jpg'
import s_2 from '@/common/images/pageHome/s-2.jpg'
import s_3 from '@/common/images/pageHome/s-3.jpg'
import s_4 from '@/common/images/pageHome/s-4.jpg'
import { isMobileAgent } from '@/utils/utils'
const HomePage = (props) => {
  const navigate = useNavigate()
  const user = new User()
  const [industryData, handleIndustry] = useState([])
  const [data, setData] = useState([])
  const form = {
    pageSize: 4,
    pageNum: 1,
    articleName: '',
    releaseColumn: '热点精选',
    releaseColumnId: ''
  }
  const query = {
    pageSize: 4,
    pageNum: 1,
    articleName: '',
    releaseColumn: '成功案例',
    releaseColumnId: ''
  }
  const componentDidMount = ()=>{
    setData([])
    user.getArticleList(query)
      .then(res => {
        setData(res.result)
      })
      .catch((res) => {
        setData([])
        console.log(res)
      })
  }
  const accountingIndustryClients = useRef('财税行业客户')
  const consultingIndustryClients = useRef('咨询行业客户')
  const enterpriseCustomers = useRef('企业客户')
  const accountantExperience = useRef('会计师体验')
  const getIndustryData = () => {
    user.getArticleList(form)
      .then(res => {
        const index = res.result && res.result.length > 0 ? res.result.length : 0
        if (index === 0) return
        handleIndustry([res.result[getRandom(0, index)], res.result[getRandom(0, index)]])
      })
      .catch((err) => {
        console.log(err, 'err')
        handleIndustry([])
      })
  }
  const getRandom = (min, max) => { // 根据最小值和最大值产生一个随机数
    return Math.floor(Math.random() * (max - min) + min)
  }

  useEffect(()=>{
    getIndustryData()
    componentDidMount()
  }, [])

  const handleNavigate = (path) => {
    window.scrollTo({
      top: 0
    })
    navigate(path)
  }
  const handleSkip = () => {
    if (isMobileAgent()) {
      window.scrollTo({
        top: 0
      })
    }
  }
  const [isSmall, handleIsSmall] = useState(false)
  const [solIsSmall, handleSolIsSmall] = useState(false)
  const [phone, handlePhone] = useState('')
  const dyClassName = (val)=>{
    return val ? styles['active-one'] : styles['active-ones']
  }
  const handleScrollTo = (id) => {
    doPrePhone(phone)
    const portalEle = document.getElementById(id)
    console.log('portalEle', portalEle)
    if (portalEle) {
      window.scrollTo({
        top: portalEle.offsetTop - 60,
        behavior: 'smooth'
      })
    }
  }
  return <section className={styles['page-home']}>

    <div className={styles['page-home-bigT']}>
      <img src={yd_head} alt='yd_head' />
      <div className={styles['page-home-gerl']}>
        <h1>概而论云记账</h1>
        <p>从未如此简单 从未如此顺畅</p>
        <div><input type='text' placeholder='请输入手机号码' value={phone} onChange={e => handlePhone(e.target.value)}/><span onClick={(e) => handleScrollTo('preOrderEx') || e.preventDefault()} >马上体验</span></div>
      </div>
    </div>

    <div className={`${styles.page_home_matter} ${styles.public} ${styles.w1250} relative`}>
      <img src={ball} className={styles['img-ball']} alt='ball' />
      <h2>您的公司是否遇到以下问题</h2>
      <div className={styles['page-home-cut']}>
        <div></div>
        <div className={dyClassName(!isSmall)} onClick={() => handleIsSmall(false)}><a href='/#' onClick={(e) => e.preventDefault()}>财税服务公司</a></div>
        <div className={dyClassName(isSmall)} onClick={() => handleIsSmall(true)}><a href='/#' onClick={(e) => e.preventDefault()}>中小企业</a></div>
        <div></div>
      </div>
      <div className={styles['page-home-details']}>
        {!isSmall ? (
          <ul className={styles['show']}>
            <li>
              <div className={styles['page-home-left']}>
                <h3>01</h3>
                <p>获客困难</p>
              </div>
              <p className={styles['page-home-right']}>
              线上获客，投入成本高，无法精准获客。线下营销，行业比较垂直，很难达到快速裂变。
              </p>
            </li>
            <li>
              <div className={styles['page-home-left']}>
                <h3>02</h3>
                <p>低价竞争</p>
              </div>
              <p className={styles['page-home-right']}>
              随着财税服务公司越来越多，行业竞争激烈，大面积采取低价策略。客户体验感差，行业口碑难树立。
              </p>
            </li>
            <li>
              <div className={styles['page-home-left']}>
                <h3>03</h3>
                <p>产品单一</p>
              </div>
              <p className={styles['page-home-right']}>
              财税服务公司产品单一。本该以技术为主导的财税服务行业成为了劳动力密集型行业。
              </p>
            </li>
            <li>
              <div className={styles['page-home-left']}>
                <h3>04</h3>
                <p>成本增加</p>
              </div>
              <p className={styles['page-home-right']}>
              房租、水电、人工成本逐年上升。人员职责不明确，管理混乱，员工、客户容易流失。
              </p>
            </li>
          </ul>
        ) : (
          <ul className={styles['show']}>
            <li>
              <div className={styles['page-home-left']}>
                <h3>01</h3>
                <p>利润虚高</p>
              </div>
              <p className={styles['page-home-right']}>
              内部管理流程不完善，导致很多无票支出，没办法给企业做成本，导致企业所得税高。
              </p>
            </li>
            <li>
              <div className={styles['page-home-left']}>
                <h3>02</h3>
                <p>人力成本</p>
              </div>
              <p className={styles['page-home-right']}>
              内部管理紊乱，导致人力资源浪费，没有一款好的软件辅导，导致财务工作量巨大。
              </p>
            </li>
            <li>
              <div className={styles['page-home-left']}>
                <h3>03</h3>
                <p>报销审批</p>
              </div>
              <p className={styles['page-home-right']}>
              报销流程不完善，导致后续报销审批滞后，无法快速核对员工报销事项，工作效率不高。
              </p>
            </li>
            <li>
              <div className={styles['page-home-left']}>
                <h3>04</h3>
                <p>财务报表</p>
              </div>
              <p className={styles['page-home-right']}>
              财务报表晦涩难懂，无法一目了然看到公司财务问题，无法及时掌握公司运营情况。
              </p>
            </li>
          </ul>
        )}

        <ul className={styles['none']}>
          <li>
            <div className={styles['page-home-left']}>
              <h3>01</h3>
              <p>获客困难</p>
            </div>
            <p className={styles['page-home-right']}>
            线上获客，投入成本高，无法精准获客。线下营销，行业比较垂直，很难达到快速裂变。
            </p>
          </li>
          <li>
            <div className={styles['page-home-left']}>
              <h3>02</h3>
              <p>低价竞争</p>
            </div>
            <p className={styles['page-home-right']}>
            随着代账公司越来越多，行业竞争激烈，大面积采取低价代账。客户体验感差，行业口碑难树立。
            </p>
          </li>
          <li>
            <div className={styles['page-home-left']}>
              <h3>03</h3>
              <p>产品单一</p>
            </div>
            <p className={styles['page-home-right']}>
            代账公司产品单一。本该以技术为主导的代理记账行业成为了劳动力密集型行业。
            </p>
          </li>
          <li>
            <div className={styles['page-home-left']}>
              <h3>04</h3>
              <p>成本增加</p>
            </div>
            <p className={styles['page-home-right']}>
            房租、水电、人工成本逐年上升。人员职责不明确，管理混乱，员工、客户容易流失。
            </p>
          </li>
        </ul>
      </div>
    </div>

    {/* 解决方案 */}
    <div className={styles['page-home-scheme']}>
      <div className={`${styles.page_home_scheme2} ${styles.public} ${styles.w1250}`}>
        <h2>解决方案</h2>
        <div className={styles['page-home-cut']}>
          <div></div>
          <div className={dyClassName(!solIsSmall)} onClick={() => handleSolIsSmall(false)}><a href='/#' onClick={(e) => e.preventDefault()}>财税服务公司</a></div>
          <div className={dyClassName(solIsSmall)} onClick={() => handleSolIsSmall(true)}><a href='/#' onClick={(e) => e.preventDefault()}>中小企业</a></div>
          <div></div>
        </div>
        {!solIsSmall ? (
          <ul>
            <li>
              <img src={yds_1} alt='yds_1' className={styles['yd_s']} />
              <img src={s_1} alt='s_1' className={styles['pc_s']} />
              <div>
                <div>票据管理</div>
                <a href='/#' onClick={(e) => handleNavigate('/sol-bill') || e.preventDefault()}><i>了解更多</i><span>&gt;</span></a>
              </div>
            </li>
            <li>
              <img src={yds_2} alt='yds_2' className={styles['yd_s']} />
              <img src={s_2} alt='s_2' className={styles['pc_s']} />
              <div>
                <div>智能财税</div>
                <a href='/#' onClick={(e) => handleNavigate('/sol-wealth') || e.preventDefault()}><i>了解更多</i><span>&gt;</span></a>
              </div>
            </li>
            <li>
              <img src={yds_3} alt='yds_3' className={styles['yd_s']} />
              <img src={s_3} alt='s_3' className={styles['pc_s']} />
              <div>
                <div>运营管理</div>
                <a href='/#' onClick={(e) => handleNavigate('/sol-operation') || e.preventDefault()}><i>了解更多</i><span>&gt;</span></a>
              </div>
            </li>
            <li>
              <img src={yds_4} alt='yds_4' className={styles['yd_s']} />
              <img src={s_4} alt='s_4' className={styles['pc_s']} />
              <div>
                <div>报销管理</div>
                <a href='/#' onClick={(e) => handleNavigate('/sol-apply') || e.preventDefault()}><i>了解更多</i><span>&gt;</span></a>
              </div>
            </li>
          </ul>
        ) : (
          <ul>
            <li>
              <img src={s_1} alt='s_1' className={styles['pc_s']} />
              <img src={yds_1} alt='yds_1' className={styles['yd_s']} />
              <div>
                <div>票据管理</div>
                <a href='/#' onClick={(e) => handleNavigate('/sol-bill') || e.preventDefault()}><i>了解更多</i><span>&gt;</span></a>
              </div>
            </li>
            <li>
              <img src={s_2} alt='s_2' className={styles['pc_s']} />
              <img src={yds_2} alt='yds_2' className={styles['yd_s']} />
              <div>
                <div>智能财税</div>
                <a href='/#' onClick={(e) => handleNavigate('/sol-wealth') || e.preventDefault()} ><i>了解更多</i><span>&gt;</span></a>
              </div>
            </li>
            <li>
              <img src={s_3} alt='s_3' className={styles['pc_s']} />
              <img src={yds_3} alt='yds_3' className={styles['yd_s']} />
              <div>
                <div>报销管理</div>
                <a href='/#' onClick={(e) => handleNavigate('/sol-apply') || e.preventDefault()} ><i>了解更多</i><span>&gt;</span></a>
              </div>
            </li>
            <li>
              <img src={s_4} alt='s_4' className={styles['pc_s']} />
              <img src={yds_4} alt='yds_4' className={styles['yd_s']} />
              <div>
                <div>特色增值</div>
                <a href='/#' onClick={(e) => handleNavigate('/sol-appreciation') || e.preventDefault()}><i>了解更多</i><span>&gt;</span></a>
              </div>
            </li>
          </ul>
        )}

      </div>
    </div>

    {/* 产品中心 */}
    <div className={styles['product-center']}>
      <img src={yd_product} alt = 'yd_product' className={styles['yd_product']} />
      <img src={product_bg} alt = 'product_bg' className={styles['product_bg']} />
      <div>
        <p>产品中心</p>
        <a href='/#' onClick={(e) => handleNavigate('/serve') || e.preventDefault()}>了解更多</a>
      </div>
    </div>

    {/* 行业资讯 */}
    <div className={`${styles.page_home_news} ${styles.public} ${styles.w1250}`}>
      <h2>行业资讯</h2>
      <div className={styles['industry']}>
        {
          industryData.map(item => {
            return <div key={item.id} onClick={handleSkip} className={styles['industry-content']} >
              <Link to={{ pathname: `/listParticulars/` + item.id }} target='_blank'>
                <div className={styles['industry-img']}>
                  { item.thumbnails && item.thumbnails.length > 0 ? <img src={item.thumbnails[0].url} alt={item.thumbnails[0].name} /> : '' }
                </div>
                <p>{item.articleName}</p>
              </Link>
            </div>
          })
        }
      </div>
    </div>

    {/* 成功案例 */}
    <div className={`${styles.page_home_case} ${styles.public}`}>
      <h2>成功案例</h2>
      <ul className={`${styles.w1250}`}>
        <li>
          <a href='/#' onClick={(e) => e.preventDefault()}></a>
          <div className={styles['solution-mask']}>
            <a href='/#' onClick={(e) => e.preventDefault()}>
              <p>{accountingIndustryClients.current}</p>
              <div className={styles['pc-only-item'] + ' ' + styles['line']}></div>
            </a>
            <a href='/#' className={styles['pc-only-item'] + ' ' + styles['more']} onClick={(e)=> handleNavigate(('/case-dtl/' + data[0].id)) || e.preventDefault()}>查看详情</a>
          </div>
        </li>
        <li>
          <a href='/#' onClick={(e) => e.preventDefault()}></a>
          <div className={styles['solution-mask']}>
            <a href='/#' onClick={(e) => e.preventDefault()}>
              <p>{consultingIndustryClients.current}</p>
              <div className={styles['pc-only-item'] + ' ' + styles['line']}></div>
            </a>
            <a href='/#' className={styles['pc-only-item'] + ' ' + styles['more']} onClick={(e)=> handleNavigate(('/case-dtl/' + data[3].id)) || e.preventDefault()}>查看详情</a>
          </div>
        </li>
        <li>
          <a href='/#' onClick={(e) => e.preventDefault()}></a>
          <div className={styles['solution-mask']}>
            <a href='/#' onClick={(e) => e.preventDefault()}>
              <p>{enterpriseCustomers.current}</p>
              <div className={styles['pc-only-item'] + ' ' + styles['line']}></div>
            </a>
            <a href='/#' className={styles['pc-only-item'] + ' ' + styles['more']} onClick={(e)=> handleNavigate(('/case-dtl/' + data[1].id)) || e.preventDefault()}>查看详情</a>
          </div>
        </li>
        <li>
          <a href='/#' onClick={(e) => e.preventDefault()}></a>
          <div className={styles['solution-mask']}>
            <a href='/#' onClick={(e) => e.preventDefault()}>
              <p>{accountantExperience.current}</p>
              <div className={styles['pc-only-item'] + ' ' + styles['line']}></div>
            </a>
            <a href='/#' className={styles['pc-only-item'] + ' ' + styles['more']} onClick={(e)=> handleNavigate(('/case-dtl/' + data[2].id)) || e.preventDefault()}>查看详情</a>
          </div>
        </li>
      </ul>
    </div>
  </section>
}

export default HomePage
